import React, { ComponentProps } from 'react';
import toast from 'react-hot-toast';
import { Button, Splash } from 'shared/Components';
import { FlexRow } from 'shared/Typhography/flex-box';

import { ModalWrapper } from '../styled';

interface ConfirmationModalProps {
  title: React.ReactNode;
  content: React.ReactNode;
  close: () => void;
  confirm: () => Promise<void> | void;
  cancel?: () => Promise<void> | void;
  cancelButtonVariant?: ComponentProps<typeof Button>['variant'];
  confirmButtonVariant?: ComponentProps<typeof Button>['variant'];
}

export const ConfirmationModal = ({
  close,
  confirm,
  cancel,
  title,
  content,
  cancelButtonVariant,
  confirmButtonVariant,
}: ConfirmationModalProps) => {
  const [isLoading, setLoading] = React.useState<boolean>(false);
  const [loadingPosition, setLoadingPosition] = React.useState<'cancel' | 'confirm'>();

  return (
    <ModalWrapper>
      <FlexRow justifyContent="flex-end">
        <div style={{ flex: 1 }}>{title}</div>
        <span
          style={{ cursor: 'pointer', fontSize: '20px' }}
          onClick={() => {
            if (!isLoading) close();
          }}
        >
          x
        </span>
      </FlexRow>
      <div style={{ flex: 1, width: '100%' }}>{content}</div>
      <FlexRow dimensions={{ width: '100%' }} alignItems="center">
        <div style={{ flex: 1 }}>
          <Button
            minWidth={200}
            height={40}
            style={{ paddingLeft: '16px', paddingRight: '16px' }}
            variant={cancelButtonVariant}
            disabled={isLoading}
            onClick={async () => {
              try {
                if (cancel) {
                  setLoadingPosition('cancel');
                  setLoading(true);
                  await cancel();
                  setLoading(false);
                }

                close();
              } catch (err) {
                console.log(err);
                /* TODO Add Translations */
                toast.error('Failed to cancel action');
              }
            }}
          >
            {isLoading && loadingPosition === 'cancel' && <Splash width={24} height={24} />}
            {(!isLoading || (isLoading && loadingPosition === 'confirm')) && (
              <>
                {/* TODO Add Translations */}
                Cancel
              </>
            )}
          </Button>
        </div>
        <div style={{ flex: 1 }}>
          <Button
            minWidth={200}
            height={40}
            disabled={isLoading}
            style={{ paddingLeft: '16px', paddingRight: '16px' }}
            variant={confirmButtonVariant}
            onClick={async () => {
              try {
                setLoadingPosition('confirm');
                setLoading(true);
                await confirm();
                setLoading(false);
              } catch (err) {
                console.log(err);
                /* TODO Add Translations */
                toast.error('Failed to confirm action');
              }
            }}
          >
            {/* TODO Add Color to Loading component */}
            {/* TODO Take color from theme */}
            {isLoading && loadingPosition === 'confirm' && <Splash width={20} height={20} />}
            {(!isLoading || (isLoading && loadingPosition === 'cancel')) && (
              <>
                {/* TODO Add translations */}
                Confirm
              </>
            )}
          </Button>
        </div>
      </FlexRow>
    </ModalWrapper>
  );
};
